import { render, staticRenderFns } from "./AddTestKit.vue?vue&type=template&id=f6d66c74&scoped=true&"
import script from "./AddTestKit.vue?vue&type=script&lang=js&"
export * from "./AddTestKit.vue?vue&type=script&lang=js&"
import style0 from "./AddTestKit.vue?vue&type=style&index=0&id=f6d66c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d66c74",
  null
  
)

export default component.exports